import { inject, Injectable } from '@angular/core';
import { jkLib } from './jkCommon';
import { jkRestReturn, CR } from './jkInterface';
import { login, LoginService } from './jkUser';
import { OrmService } from './jkOrm';

@Injectable({
  providedIn: 'root',
})
export class JkpowerService {
  editPower: boolean = true;
  //checkPower: boolean = true;
  queryPower: boolean = true;
  insertPower: boolean = true;
  deletePower: boolean = true;
  printPower: boolean = true;
  confirmPower: boolean = true;
  adminPower: boolean = true;
  executePower: boolean = true;
  dataPower: boolean = true;
  superPower: boolean = false;
  unConfirmPower: boolean = true;
  outputPower: boolean = true;
  moneyPower: boolean = true;
  moneyReadOnlyPower: boolean = true;
  pricePower: boolean = true;
  priceReadOnlyPower: boolean = true;
  orm: OrmService = inject(OrmService);
  adminList: string[] = [];
  isAdmin: boolean = false;
  mPower1 = 'N';
  mPower2 = 'N';
  mPower3 = 'NNNNNNNNNNNN';
  mPower4 = 'NNNNNNNNNNNN';
  mPower5 = 'NNNNNNNNNNNN';
  constructor() {
    if (login.customid === 'KM') {
      this.adminList.push('JACKIE');
      this.adminList.push('JACK');
      this.adminList.push('ADMIN');
    };
  }
  setSuperPower() {
    this.mPower1 = 'Y';
    this.mPower2 = 'Y';
    this.mPower3 = 'YYYYYYYYYYYY';
    this.mPower4 = 'YYYYYYYYYYYY';
    this.mPower5 = 'YYYYYYYYYYYY';
    this.superPower = true;
  }
  clearPower() {
    this.mPower1 = 'N';
    this.mPower2 = 'N';
    this.mPower3 = 'NNNNNNNNNNNN';
    this.mPower4 = 'NNNNNNNNNNNN';
    this.mPower5 = 'NNNNNNNNNNNN';
    this.superPower = false;
  }
  async setPower(programId: string, login: LoginService, ret: jkRestReturn, isCheckPower: boolean = false): Promise<boolean> {
    if (!programId) {
      console.error('setpower programId is null');
      return false;
    }
    this.clearPower();
    //this.checkPower = isCheckPower;
    //if(!this.beforeSetPower(login.uid,page.programId)) return;
    let sqlSelect = '';
    this.adminPower = false;
    sqlSelect =
      'SELECT MG003, MG004, MG005, MG006, MG007, MG008, MF004, MF005, ME003 ' +
      CR +
      'FROM ADMMF   LEFT JOIN ADMMG ON MF001=MG001 AND MG002=' +
      jkLib.quotedStr(programId.toUpperCase().trim()) +
      CR +
      ' LEFT JOIN ADMME ON MF004=ME001  ' +
      CR +
      '  WHERE MF001= ' +
      jkLib.quotedStr(login.uid);
    if (!login) return false;
    if (!isCheckPower) {
      //this.parsePower(programId, login, null, isCheckPower);
      this.setSuperPower();
      this.setEveryPower();
      return true;
    }
    let data = await this.orm.simpleSqlPromise(login.host, sqlSelect, ret);
    if (ret.result && data && data.length > 0) {
      return this.parsePower(programId, login, data[0], isCheckPower);
    } else {
      return false;
    }
  }
  parsePower(programId: string, login: LoginService, data: any, isCheckPower: boolean): boolean {
    let result = true;
    const superPowerProgramId = ['home', 'about', 'login-form'];
    if (superPowerProgramId.indexOf(programId.toLocaleLowerCase()) >= 0) {
      this.superPower = true;
    };
    const uid = login.uid.toUpperCase();
    if ((this.adminList.indexOf(uid) >= 0)) {
      this.setSuperPower();
    };
    if (!data && isCheckPower === true) {
      this.superPower = false;
    } else {
      if (isCheckPower === true) {
        if (data.MG004)
          this.mPower1 = data.MG004;
        if (data.MF005 === 'Y') {
          this.superPower = true;
        } else {
          this.superPower = false;
          if (data.MG004 === undefined || data.MG004 === null) {
            alert(
              '錯誤 程式代號:' +
              programId +
              ' 使用者:' +
              login.uid +
              '  的權限未設定!(ADMMG),資料庫名稱:' +
              login.dbname + ' 值:' + data.MG004
            );
            result = false;
          }
          if ((this.mPower1 === '') || (this.mPower1 === undefined)) {
            alert(
              '警告 程式代號:' +
              programId +
              ' 使用者:' +
              login.uid +
              '  權限設定 空白!(ADMMG),資料庫名稱:' +
              login.dbname
            );
            result = false;
          }
        }
        if (data.MG005)
          this.mPower2 = data.MG005;
        if (data.MG006)
          this.mPower3 = data.MG006;
        if (data.MG007)
          this.mPower4 = data.MG007;
        if (data.MG008)
          this.mPower5 = data.MG008;
      }
    }

    if (isCheckPower === false || this.superPower === true) { // 20260204 是 || 沒錯不要再改
      this.setSuperPower();
    }
    if (result === false) return false;
    return this.setEveryPower();
  }
  checkPower(programId: string, login: LoginService, state: string): boolean {
    /*if (!programId) {
      console.error('checkPower programId is null');
      return false;
    }
    if (!login) {
      console.error('checkPower login is null');
      return false;
    }
    if (this.adminList.indexOf(login.uid.toUpperCase()) >= 0) {
      return true;
    }
      */
    if (this.superPower) {
      return true;
    }
    let msg = '';
    if (state === 'query' && !this.queryPower) {
      msg = login.uid + ' ' + programId + ' 沒有查詢權限';
      alert(msg);
      throw new Error(msg);
    }
    if (state === 'edit' && !this.editPower) {
      msg = login.uid + ' ' + programId + ' 沒有編輯權限';
      alert(msg);
      throw new Error(msg);
    }
    if (state === 'delete' && !this.deletePower) {
      msg = login.uid + ' ' + programId + ' 沒有刪除權限';
      alert(msg);
      throw new Error(msg);
    }
    if (state === 'confirm' && !this.confirmPower) {
      msg = login.uid + ' ' + programId + ' 沒有確認權限';
      alert(msg);
      throw new Error(msg);
    }
    if (state === 'unConfirm' && !this.unConfirmPower) {
      msg = login.uid + ' ' + programId + ' 沒有取消確認權限';
      alert(msg);
      throw new Error(msg);
    }
    if (state === 'output' && !this.outputPower) {
      msg = login.uid + ' ' + programId + ' 沒有輸出權限';
      alert(msg);
      throw new Error(msg);
    }
    if (state === 'print' && !this.printPower) {
      msg = login.uid + ' ' + programId + ' 沒有列印權限';
      alert(msg);
      throw new Error(msg);
    }
    if (state === 'money' && !this.moneyPower) {
      msg = login.uid + ' ' + programId + ' 沒有金額權限';
      alert(msg);
      throw new Error(msg);
    }
    if (state === 'moneyReadOnly' && !this.moneyReadOnlyPower) {
      msg = login.uid + ' ' + programId + ' 沒有金額唯讀權限';
      alert(msg);
      throw new Error(msg);
    }
    if (state === 'price' && !this.pricePower) {
      msg = login.uid + ' ' + programId + ' 沒有價格權限';
      alert(msg);
      throw new Error(msg);
    }
    if (state === 'priceReadOnly' && !this.priceReadOnlyPower) {
      msg = login.uid + ' ' + programId + ' 沒有價格唯讀權限';
      alert(msg);
      throw new Error(msg);
    }
    if (state === 'insert' && !this.insertPower) {
      msg = login.uid + ' ' + programId + ' 沒有新增權限';
      alert(msg);
      throw new Error(msg);
    }
    return false;
  }
  setEveryPower(): boolean {

    this.executePower = this.mPower1 === 'Y' || this.mPower1 === 'y';
    this.dataPower = this.mPower2 === 'Y' || this.mPower2 === 'y';

    this.queryPower = this.mPower3.charAt(0) === 'Y';
    this.editPower = this.mPower3.charAt(1) === 'Y';
    this.deletePower = this.mPower3.charAt(2) === 'Y';
    this.confirmPower = this.mPower3.charAt(3) === 'Y';
    this.unConfirmPower = this.mPower3.charAt(4) === 'Y';
    this.outputPower = this.mPower3.charAt(5) === 'Y';
    this.printPower = this.mPower3.charAt(5) === 'Y';
    this.moneyPower = this.mPower3.charAt(6) === 'Y';
    this.moneyReadOnlyPower = this.mPower3.charAt(6) === 'R';
    this.pricePower = this.mPower3.charAt(7) === 'Y';
    this.priceReadOnlyPower = this.mPower3.charAt(7) === 'R';
    this.insertPower = this.mPower3.charAt(8) === 'Y';
    //this.checkPower = true;
    //this.isCheckPower = false;
    //this.queryPower = true;
    //this.insertPower = true;
    //this.deletePower = true;
    return this.executePower;
  }
  beforeSetPower(uid: string, programId: string): boolean {
    let boolRet = true;
    return boolRet;
  }
}
